import { holeCardsParser } from '../../../types/cardTypes';
import { pokerVariantIndexParser } from '../../../types/pokerVariantTypes';
import { booleanParser, encodedStringParser, numberParser } from '../inboundParsers';
import { seatIndexesParser } from './utils/pokerInboundUtils';
export const START_HAND_INBOUND_DEFINITION = {
    shouldSplitWithBraces: true,
    definitionParts: [
        { name: 'holeCards', parser: holeCardsParser },
        { name: 'inSeatIndexes', parser: seatIndexesParser },
        { name: 'smallBlind', parser: numberParser },
        { name: 'bigBlind', parser: numberParser },
        { name: 'minimumBet', parser: numberParser },
        { name: 'betIncrement', parser: numberParser },
        { name: 'dealerNumber', parser: numberParser },
        { name: 'sidebetAmount', parser: numberParser },
        { name: 'handsPlayedThisRoom', parser: numberParser },
        { name: 'tourneyHasStarted', parser: booleanParser },
        { name: 'dealerYellMessage', parser: encodedStringParser },
        { name: 'activeHandId', parser: numberParser },
        { name: 'isFourColorDeckActiveThisHand', parser: booleanParser },
        { name: 'pokerVariant', parser: pokerVariantIndexParser },
        { name: 'playSound', parser: booleanParser }
    ]
};
